import React from 'react'
import styled from 'styled-components'
import UrgencyLabel from 'LuxKit/Label/UrgencyLabel'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { useFlightExpiryTimer } from './CartReviewUtils'

const TimerLabel = styled(UrgencyLabel)`
  width: 23ch;
  justify-content: center;
  
  ${mediaQueryUp.tablet} {
    justify-content: flex-start;
  }
`

interface ExpiryTimerProps {
  expiry: number
  canShowExtension: boolean
}

function ExpiryTimer({ expiry, canShowExtension }: ExpiryTimerProps) {
  const { timeRemaining } = useFlightExpiryTimer(expiry)

  if (!canShowExtension || timeRemaining === '00:00') return null

  return (
    <TimerLabel variant="critical2" icon={<LineInfoCircleIcon />}>
      FLIGHT PRICE EXPIRES IN {timeRemaining}
    </TimerLabel>
  )
}

export default ExpiryTimer
